import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import dayjs from "dayjs";

export default class OrderResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "number": 1,
                "state": "INITIAL",
                "customer": {
                    "code": 5,
                    "business_name": 2,
                    "number": 2,
                    "fantasy_name": "Customer",
                    "delivery_sites": [{
                        "name": "Customer Delivery Site",
                        "address": "Address",
                        "city": "City",
                    }],
                },
                "delivery_site": {
                    "name": "Customer Delivery Site",
                    "address": "Address",
                    "city": "City",
                },
                "delivery_date": "20-05-2024",
                "observations": "An Observation",
                "articles": [
                    {
                        "article": {
                            "code": "1",
                            "name": "Articulo",
                            "fantasy_name": "Articulo Fantasia",
                            "items_amount": "20",
                            "category": {
                                "name": "Categoria",
                                "title": "Titulo Categoria",
                                "description": "Descripcion Categoria"
                            }
                        },
                        "quantity": 4,
                        "discount": 0,
                    },
                    {
                        // Only if state is INVOICED
                        "article": {
                            "code": "1",
                            "name": "Articulo",
                            "fantasy_name": "Articulo Fantasia",
                            "items_amount": "20",
                            "category": {
                                "name": "Categoria",
                                "title": "Titulo Categoria",
                                "description": "Descripcion Categoria"
                            }
                        },
                        "quantity": 4,
                        "discount": 0,
                        "unit_price": {
                            'amount': 60.00,
                            'currency': "ARS"
                        },
                        "price": {
                            'amount': 1200.00,
                            'currency': "ARS"
                        }
                    }
                ]
            },
            errors: []
        }
    }

    order() {
        return {
            number: this.number(),
            purchaseOrderNumber: this.purchaseOrderNumber(),
            state: this.state(),
            customer: this.customer(),
            deliverySite: this.deliverySite(),
            deliveryDate: this.deliveryDate(),
            observations: this.observations(),
            articles: this.articles(),
            isFree: this.isFree(),
        }
    }

    number() {
        return this.content().number;
    }

    isFree() {
        return this.content().is_free || false;
    }

    purchaseOrderNumber() {
        return this.content().customers_order_number;
    }

    state() {
        return this.content().state;
    }

    customer() {
        const customer = this.content().customer
        return {
            code: customer.code,
            businessName: customer.business_name,
            customerCode: customer.code,
            fantasyName: customer.fantasy_name,
        }
    }

    deliverySite() {
        const deliverySite = this.content().delivery_site
        return {
            deliverySiteCode: deliverySite.code,
            deliverySiteName: deliverySite.name,
            deliverySiteAddress: deliverySite.location.address,
            deliverySiteCity: deliverySite.location.city,
            deliveryDate: "",
        }
    }

    deliveryDate() {
        const deliveryDate = this.content().delivery_date;
        return dayjs(deliveryDate, 'DD-MM-YYYY');
    }

    observations() {
        return this.content().observations
    }

    articles() {
        const state = this.content().state;
        
        return this.content().articles.map(articleWithAmount => {
                const article = {
                    code: articleWithAmount.article.code,
                    name: articleWithAmount.article.name,
                    family: articleWithAmount.article.category.name,
                    amount: articleWithAmount.quantity,
                    discount: articleWithAmount.discount
                }
                if (state === 'INVOICED') {
                    article.fantasyName = articleWithAmount.article.fantasy_name
                    article.price = articleWithAmount.price
                    article.unitPrice = articleWithAmount.unit_price
                }

                return article
            }
        )
    }
}